export const DataConf = {
  initialState: {
    loading: false,
    error: null,
    data: [],
    meta: null,
  },
};

export const AreaOptions = [
  {
    id: null,
    label: 'NONE'
  },
  {
    id: 'NORD',
    label: 'NORTH'
  },
  {
    id: 'SUD',
    label: 'SOUTH'
  },
  {
    id: 'CARIBBEAN',
    label: 'CARIBBEAN'
  },
];
